import React from 'react';

import { Breadcrumbs, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { gray } from '../../constants/Colors';
import { mypageHeader, mypageHeaderTitle } from '../../constants/Location';
import { screenType } from '../../constants/enum';

import RegisterOrientationCard from './RegisterOrientationCard';

const styles = {
  breadcrumbs: {
    '.MuiBreadcrumbs-separator': {
      margin: '0 8px 2px 8px'
    },
    display: 'flex',
    fontSize: '12px',
    margin: '12px 0 0 24px'
  },
  breadcrumbsText: {
    color: gray,
    fontSize: '12px'
  },
  mypageHeader,
  mypageHeaderTitle
};

interface Props {
  screen: number;
}

const MypageOrientationEdit: React.FC<Props> = (props) => {
  const { screen } = props;
  const { t } = useTranslation();
  const url = new URL(window.location.href);
  const params = url.searchParams;
  const type = params.get('type')?.split('?').join('') ?? '';
  const issueId = params.get('id')?.split('?').join('') ?? '';
  const copyIssueId = params.get('copyId')?.split('?').join('') ?? '';

  let href;
  if (screen === screenType.client) {
    href = '/main/client/mypage/issue';
  } else if (screen === screenType.agent) {
    href = '/main/agent/mypage/issue';
  }
  let editHref;
  if (screen === screenType.client) {
    editHref = `/main/client/mypage/issue/edit?type=edit&id=${issueId}`;
  } else if (screen === screenType.agent) {
    editHref = `/main/agent/mypage/issue/edit?type=edit&id=${issueId}`;
  }
  const breadcrumbs = [
    <Link underline="hover" key="1" href={href} sx={styles.breadcrumbsText}>
      {t('mypage.issueList')}
    </Link>,
    <Link underline="hover" key="2" href={editHref} sx={styles.breadcrumbsText}>
      {type === 'edit'
        ? t('mypage.issueEdit')
        : type === 'add'
        ? t('mypage.addIssue')
        : type === 'copy'
        ? t('mypage.issueCopy')
        : t('mypage.addIssue')}
    </Link>,
    <Typography key="3" sx={styles.breadcrumbsText}>
      {t('mypage.orientation')}
    </Typography>
  ];

  return (
    <Typography
      component="div"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        position: 'static',
        width: '100%'
      }}
    >
      <Typography sx={styles.mypageHeader} component="div">
        <Typography sx={styles.mypageHeaderTitle}>
          {type === 'edit'
            ? t('mypage.issueEdit')
            : type === 'add'
            ? t('mypage.addIssue')
            : type === 'copy'
            ? t('mypage.issueCopy')
            : t('mypage.addIssue')}
        </Typography>
      </Typography>
      <Breadcrumbs
        separator=">"
        aria-label="breadcrumb"
        sx={styles.breadcrumbs}
      >
        {breadcrumbs}
      </Breadcrumbs>
      <RegisterOrientationCard screen={screen} copyIssueId={copyIssueId} />
    </Typography>
  );
};

export default MypageOrientationEdit;
